export default function PHP_libxml_get_errors() {
  return (
    <div>
      <h1>PHP_libxml_get_errors</h1>
    </div>
  );
}
